import React, { useContext } from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate
}
    from 'react-router-dom'
import { AdminNavigator } from '../../navigator/admin.navigator';
import { DashboardScreen } from '../common/dashboard.screen';
import { LoginScreen } from './login.screen';
import { SignInScreen } from '../common/sign_in.screen';
import { UserContext } from '../../App';
export const AdminApp = () => {
    const { user } = useContext(UserContext);
    const navigator = AdminNavigator(user);
    return <BrowserRouter
        future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }}
    >
        <Routes>
            {user.id ?
                <Route path="/" element={<DashboardScreen navigator={navigator} />}>
                    {navigator.filter(F => F.parent === undefined).map(M => <Route key={M.link} path={`${M.link}`} element={M.page} />)}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route> : [
                    <Route key="sign-in" path="/sign-in" element={<SignInScreen />} />,
                    <Route key="fallback" path="/*" element={<LoginScreen />} />,   
                ]}
        </Routes>
    </BrowserRouter>
}
